<template>
  <v-container fluid>
    <v-row class="dtv-app-bar white--text">
      <v-col class="auto align-center">
        <v-btn
          text
          color="white"
          class="text-h5 text-sm-h4"
          :href="'/s/' + $route.params.schedule + '/'"
        >
          {{ $route.params.schedule.toUpperCase() }}
        </v-btn>
        <template v-if="$route.params.team && $route.params.team !== '0'">
          <v-icon large dense color="white">mdi-chevron-right</v-icon>
          <v-btn text color="white" class="text-h5 text-sm-h4 no-uppercase">
            {{ teamNameDisplay }}
          </v-btn>
        </template>
      </v-col>
      <v-col class="d-print-none" cols="auto">
        <v-btn @click="print" :color="$vuetify.breakpoint.xs ? 'white' : 'primary'" :icon="$vuetify.breakpoint.xs" v-if="$route.meta.printable">
          <v-icon left> mdi-printer </v-icon>
          {{ $vuetify.breakpoint.smAndUp ? 'Print' : '' }}
        </v-btn>
      </v-col>
      <v-col order="2" cols="12">
        <v-row class="flex-row-reverse">
          <v-col class="auto text-right text-sm-center">
            <v-btn
              text
              :outlined="monthActive(index)"
              :color="monthActive(index) ? 'white' : 'grey lighten-1'"
              class="font-weight-bold pa-0"
              :class="monthActive(index) ? 'd-print-block' : 'd-print-none'"
              @click.prevent="changeMonth(index)"
              v-for="(month, index) in months.options"
              v-bind:key="index"
            >
              {{ month.text }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      
    </v-row>
    <list class="pt-10"></list>
  </v-container>
</template>


<script>
import List from "../components/Home/List";

import { GET_MONTHS, GET_SEASON_EVENTS } from "../store/actions.type";

export default {
  name: "Season",
  components: {
    List,
  },
  computed: {
    months() {
      return this.$store.getters.getCurrentMonths.months;
    },
    teamNameDisplay() {
      //Get team name from parameter
      var team = this.$route.params.team;

      // Remove dashes and numbers
      team = team.replace(/-/g, " ").replace(/\d+$/, "");

      //Force Title Case
      team = this.toTitleCase(team);

      return team;
    },
  },
  methods: {
    changeMonth(index) {
      var team = this.$route.params.team ?? 0;
      window.open(
        "/s/" +
          this.$route.params.schedule +
          "/" +
          team +
          "/" +
          this.months.options[index].year +
          "/" +
          this.months.options[index].month,
        "_self"
      );
    },
    monthActive(index) {
      if (this.$route.params.month && this.$route.params.year) {
        return (
          this.months.options[index].month == this.$route.params.month &&
          this.months.options[index].year == this.$route.params.year
        );
      } else {
        var d = new Date();
        var n = d.getMonth();
        if (this.months.options[index].month == n + 1) {
          return true;
        }
      }
      return false;
    },
    print() {
      window.print();
    },
  },
  mounted() {
    this.$gtag.event("api", {
      event_category: "events",
      event_label: "get_season_events",
    });
    this.$store.dispatch(GET_SEASON_EVENTS, {
      ScheduleTextID: this.$route.params.schedule,
      TeamTextID: this.$route.params.team,
      Year: this.$route.params.year,
      Month: this.$route.params.month,
    });
    this.$gtag.event("api", {
      event_category: "options",
      event_label: "get_season_months",
    });
    this.$store.dispatch(GET_MONTHS, {
      ScheduleTextID: this.$route.params.schedule,
    });
  },
};
</script>


<style scoped>
.v-btn--outlined {
  border-color: white !important;
}
.dtv-app-bar {
  background-color: #1d2329;
}
.no-uppercase {
  text-transform: none;
}
</style>